import "react";
import { jsx as o } from "react/jsx-runtime";
var i = (r) => /* @__PURE__ */ o("svg", {
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...r,
  children: /* @__PURE__ */ o("path", {
    d: "m16 14-4-4-4 4",
    stroke: "#1565c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })
});
export {
  i as default
};

//# sourceMappingURL=ArrowUp.js.map